import { newsFlash } from '@/mocks/home';

const tagToneMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-800',
  accent: 'bg-accent-100 text-accent-900',
  secondary: 'bg-secondary-100 text-secondary-900',
};

const dotToneMap: Record<string, string> = {
  primary: 'bg-primary-500',
  accent: 'bg-accent-500',
  secondary: 'bg-secondary-500',
};

export default function NewsFlash() {
  return (
    <section id="flash" className="scroll-mt-20 border-b border-background-200 bg-background-50">
      <div className="mx-auto w-full max-w-[1200px] px-4 py-14 md:px-6 md:py-16">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div className="max-w-2xl">
            <h2 className="font-heading text-3xl text-foreground-950 md:text-4xl">入口快讯流</h2>
            <p className="mt-3 text-sm leading-7 text-foreground-700 md:text-base">
              线路维护、入口新增与热榜变化按时间实时同步，往下滑一遍就能掌握最新动态。
            </p>
          </div>
          <span className="flex shrink-0 items-center gap-2 self-start text-xs text-foreground-500 md:self-auto">
            <span className="h-1.5 w-1.5 animate-pulse-dot rounded-full bg-primary-500"></span>
            今日 6 条更新
          </span>
        </div>

        <ol className="mt-9">
          {newsFlash.map((item, index) => (
            <li
              key={item.id}
              className="grid grid-cols-[56px_1fr] gap-3 md:grid-cols-[92px_1fr] md:gap-5"
            >
              <div className="pt-1 text-right">
                <span className="font-heading text-base text-foreground-900 md:text-lg">{item.time}</span>
              </div>

              <div
                className={`relative border-l border-background-300 pl-5 md:pl-7 ${
                  index === newsFlash.length - 1 ? 'pb-0' : 'pb-7'
                }`}
              >
                <span
                  className={`absolute -left-[5px] top-1.5 h-2.5 w-2.5 rounded-full ring-4 ring-background-50 ${dotToneMap[item.tagTone]}`}
                ></span>

                <div className="flex flex-wrap items-center gap-2">
                  <span className={`rounded-full px-2.5 py-0.5 text-[11px] ${tagToneMap[item.tagTone]}`}>
                    {item.tag}
                  </span>
                  <h3 className="text-base text-foreground-950 md:text-lg">{item.title}</h3>
                </div>
                <p className="mt-2 text-sm leading-6 text-foreground-600">{item.summary}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}